export interface InputItem {
  label: string;
  type: string;
  placeholder: string;
  name: any;
  hasTransactionFee?: boolean;
  hasBeneficiary?: boolean;
  accountName?: boolean;
  hasIcon?: boolean;
}

export interface TransferTypeHeadingProps {
  transferTitle: string;
  transferSubTitle: string;
}

export const transferTypeHeadingData: TransferTypeHeadingProps[] = [
  {
    transferTitle: "Send money to Fipay account",
    transferSubTitle: "Enter recipient’s payment information",
  },
  {
    transferTitle: "Send money to bank account",
    transferSubTitle: "Enter recipient’s payment information",
  },
  {
    transferTitle: "Wire Transfer",
    transferSubTitle: "Enter recipient’s payment information",
  },
  {
    transferTitle: "Pay Anyone",
    transferSubTitle: "Enter recipient’s payment information",
  },
];

export const options = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];
export const schedulePeriod = [
  { key: "weekly", value: "Weekly" },
  { key: "monthly", value: "Monthly" },
  { key: "quarterly", value: "Quarterly" },
  { key: "annually", value: "Annually" },
];

export const date = [
  {
    type: "text",
    name: "startDate",
    label: "Start Date",
    placeholder: "Select Date",
    icon: "/assets/svg/calendar.svg",
  },
  {
    type: "text",
    name: "endDate",
    label: "End Date",
    placeholder: "Select Date",
    icon: "/assets/svg/calendar.svg",
  },
];

export const selectBeneficiary = [
  { name: "oyindamola", value: "oyindamola" },
  { name: "valentine", value: "valentine" },
  { name: "emmanuel", value: "emmanuel" },
  { name: "ediomo", value: "ediomo" },
  { name: "blossom", value: "blossom" },
  { name: "olawale", value: "olawale" },
  { name: "oluwasegun", value: "oluwasegun" },
  { name: "clement", value: "clement" },
  { name: "mary", value: "mary" },
];
